import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { useAnchor } from "hooks";
import { DataTestId } from "types/enums/testId";
import { Introduction1Content } from "types/graphql/generated";
import { TitleWithBackground } from "./components";
import { Card } from "./components/Card";

interface Props {
  className?: string;
  content: Introduction1Content;
}

const Introduction1: VFC<Props> = withErrorBoundary(({ content: { introduction1Title, introduction1Card } }) => {
  useAnchor("introduction1");

  return (
    <StyledIntroduction className="introduction1" data-testid={DataTestId.Introduction1Container}>
      <TitleWithBackground content={introduction1Title} />

      <div className="Content">
        <Card content={introduction1Card} className="Introduction1__card" />
      </div>
    </StyledIntroduction>
  );
}, {});

const StyledIntroduction = styled.section`
  margin-top: -64px;
  padding-top: 64px;
  position: relative;
  z-index: 0;

  .Introduction1__card {
    margin-top: -426px;
    box-shadow: 0 48px 40px -8px rgb(20 20 20 / 12%);
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .Introduction1__card {
      margin-top: unset;
      box-shadow: unset;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Introduction1__card {
      margin-top: 0;
    }
  }
`;

gql`
  fragment Introduction1Content on ComponentIntroductionIntroduction1 {
    introduction1Title {
      ...Introduction1TitleContent
    }
    introduction1Card {
      ...Introduction1CardContent
    }
  }
`;

export { Introduction1 };
export type { Props as Introduction1Props };
